import endSearchConversation from '../actions/endSearchConversation';
import getSubstrateSearchScenarioBySearchScenarioId from '../utils/getSubstrateSearchScenarioBySearchScenarioId';
import { orchestrator } from 'satcheljs';
import {
    lazyClearLocalContentInstrumentationCache,
    lazyFlushNonRenderedItemsFromCache,
} from 'owa-search-service';

/**
 * This orchstrator flushes the event cache for a particular search conversation
 * once the search conversation ends.
 *
 * A "conversation" is defined as a series of keystrokes follow by either:
 *  - A click on a suggestion
 *  - A search query being issued
 *  - Abandonment (search session ends)
 */
export default orchestrator(endSearchConversation, actionMessage => {
    const { scenarioId } = actionMessage;

    // Flush cache since conversation has ended.
    lazyFlushNonRenderedItemsFromCache.importAndExecute(
        getSubstrateSearchScenarioBySearchScenarioId(scenarioId)
    );
    lazyClearLocalContentInstrumentationCache.importAndExecute();
});
